<template>
    <v-dialog v-model="model" max-width="600" persistent v-if="!showErrorDialog">
        <v-card>
            <v-card-title class="error-title">
                <v-row class="justify-center py-2">
                    <v-icon class="mr-4" color="white" name="mdi-close-circle-outline" />
                    <span>Duplicação de CNPJ</span>
                </v-row>
            </v-card-title>
            <v-card-text class="py-4">
                <div class="d-flex flex-row justify-center">
                    <h4>Existem outros hotéis cadastrados com esse CNPJ:</h4>
                </div>
                <div v-for="hotel in hotels" class="mt-2">
                    <div class="d-flex flex-row justify-space-between">
                        <h4 class="d-flex flex-column justify-center">{{ hotel.name }}</h4>
                        <v-btn
                            color="primary"
                            plain
                            @click="handleHotelAction(hotel)"
                        >
                            {{ hotel.deleted_at ? 'Restaurar e editar' : 'Editar' }}
                        </v-btn>
                    </div>
                    <v-divider class="my-1"/>
                </div>
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn color="error" plain @click="closeDialog()">OK</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <ResponseDialog
        v-model="showErrorDialog"
        :type="'error'"
        :message="errorMessage"
        @close="showErrorDialog = false"
        v-else
    />
</template>

<script>
import ResponseDialog from './ResponseDialog.vue';

export default {
    name: "DuplicatedHotelsDialog",
    components: { ResponseDialog },
    props: ['model', 'hotels'],
    data() {
        return {
            showErrorDialog: false,
            errorMessage: ''
        }
    },
    methods: {
        editHotel(hotelId) {
            const routeData = this.$router.resolve({name: 'editHotel', params: {id: hotelId}});
            window.open(routeData.href)
        },
        closeDialog() {
            this.$emit('close');
            this.$emit('update:model', false);
        },
        handleHotelAction(hotel) {
            if (hotel.deleted_at) {
                this.restoreAndEditHotel(hotel.id);
            } else {
                this.editHotel(hotel.id);
            }
        },
        async restoreAndEditHotel(hotelId) {
            await axios.post(`/api/hotel/${hotelId}/restore`)
                .then(res => {
                    if (res.data.success) {
                        this.editHotel(hotelId);
                    } else {
                        throw res;
                    }
                })
                .catch(error => {
                    if (error.response?.data?.message) {
                        this.errorMessage = error.response.data.message;
                    } else {
                        this.errorMessage = 'Ocorreu um erro ao restaurar o hotel.';
                    }
                    this.showErrorDialog = true;
                })
        }
    }
}
</script>

<style scoped>
.error-title {
    background-color: #f44336;
    color: #FFF;
    width: 100%;
}
</style>